// extracted by mini-css-extract-plugin
export var aiStarIcon = "_lj-2";
export var container = "_lj-4";
export var dismissButton = "_lj-3";
export var hasPaddingBottom = "_lj-6";
export var last = "_lj-e";
export var scrollbarThumb = "_lj-c";
export var scrollbarTrack = "_lj-b";
export var selected = "_lj-9";
export var spin = "_lj-1";
export var spinning = "_lj-0";
export var suggestionItem = "_lj-d";
export var suggestionsPanel = "_lj-5";
export var tonePill = "_lj-8";
export var tonesContainer = "_lj-7";
export var unselected = "_lj-a";